import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};

export const reload = () => {
  window.location.reload();
};
